import { FormState } from "./FormState";
import { crearServicioEntrenamiento, NuevoServicioEntrenamiento } from "../../../services/entrenamientoServicios";
import {parseCurrency} from "../../../utils/numberUtils";

const generarNuevoServicioEntrenamiento = (formState: FormState): NuevoServicioEntrenamiento => {
    return {
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.wasTouched ? formState.descripcion.value : undefined,
        numeroSesiones: parseInt(formState.numeroSesiones.value),
        precioTotal: parseCurrency(formState.precioTotal.value, "$", ",")
    }
}

export const crearNuevoServicioGuarderia = async (formState: FormState) => {
    const nuevoServicio = generarNuevoServicioEntrenamiento(formState);
    await crearServicioEntrenamiento(nuevoServicio);
}